import axios from 'axios';
import { SUPPORT_FORM_URL } from './constants';
import { SupportSubmitResult, SupportTicketResponse } from './types';

const TICKET_NUMBER_REGEX = /[?&]ticket_number=([^&]+)/;

export class SupportService {
  /**
   * Создаёт обращение в техподдержку. Авторизация не требуется.
   *
   * Эндпоинт может вести себя двумя способами, поэтому успех определяем
   * устойчиво к обоим:
   *  1. JSON-контракт интеграции — `{ status: 'ok' | 'error', ticket_number, detail }`.
   *  2. Серверная веб-форма — успех = редирект (303) на
   *     `/...support/success?ticket_number=...` (браузер сам идёт по редиректу,
   *     номер тикета достаём из итогового URL).
   * Ошибки валидации (HTTP 422 и пр.) приходят как reject и ловятся в компоненте.
   */
  static createTicket = async (
    formData: FormData
  ): Promise<SupportSubmitResult> => {
    const response = await axios.post<SupportTicketResponse | string>(
      SUPPORT_FORM_URL,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    const { data } = response;

    if (data && typeof data === 'object') {
      return {
        ok: data.status === 'ok',
        ticketNumber: data.ticket_number,
        detail: data.detail,
      };
    }

    const finalUrl =
      (response.request as { responseURL?: string } | undefined)?.responseURL ??
      '';
    const ticketMatch = finalUrl.match(TICKET_NUMBER_REGEX);

    if (finalUrl.includes('/success') || ticketMatch) {
      return {
        ok: true,
        ticketNumber: ticketMatch
          ? decodeURIComponent(ticketMatch[1])
          : undefined,
      };
    }

    return { ok: false };
  };
}
